import { render, staticRenderFns } from "./plantaAbateForm.vue?vue&type=template&id=2a705c9b&scoped=true&"
import script from "./plantaAbateForm.vue?vue&type=script&lang=js&"
export * from "./plantaAbateForm.vue?vue&type=script&lang=js&"
import style0 from "./plantaAbateForm.vue?vue&type=style&index=0&id=2a705c9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a705c9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VFlex,VForm,VLayout,VTextField})
